import { WALLET_TRANSACTION } from '../actionTypes';

export const fetchWalletTransaction = (action) => ({
  type: WALLET_TRANSACTION.FETCH,
  payload: action.payload,
});
